import { Center, ICenterProps } from '@zorro/web/design-system';

import classNames from './NumberTag.module.scss';

type Props = ICenterProps & {
  index: number;
  variant?: 'primary' | 'secondary';
};

/* eslint-disable id-length */
export const NumberTag = ({
  index,
  style,
  variant = 'primary',
  w = '1.5rem',
  h = '1.5rem',
}: Props) => {
  return (
    <Center
      data-variant={variant}
      className={classNames.root}
      style={style}
      w={w}
      h={h}
    >
      {index}
    </Center>
  );
};
